'use client';
// based on https://daypicker.dev/start

import * as React from 'react';
import { DayPicker, PropsBase, PropsSingle } from 'react-day-picker';
import { cx } from 'class-variance-authority';
import CalendarDropdown from './components/CalendarDropdown';

import 'react-day-picker/style.css';
import styles from './calendar.module.scss';

export type CalendarProps = React.ComponentProps<typeof DayPicker>;

function Calendar({
  className,
  classNames,
  showOutsideDays = true,
  ...props
}: PropsBase & PropsSingle) {
  return (
    <DayPicker
      showOutsideDays={showOutsideDays}
      className={cx(styles.calendar, className)}
      classNames={{
        day: styles.day,
        day_button: styles.dayButton,
        selected: styles.selected,
        focused: styles.focused,
        outside: styles.outside,
        today: styles.today,
        disabled: styles.disabled,
        button_previous: styles.navButton,
        button_next: styles.navButton,
        ...classNames
      }}
      components={{
        Dropdown: CalendarDropdown
      }}
      captionLayout="dropdown"
      hideNavigation
      {...props}
    />
  );
}

Calendar.displayName = 'Calendar';

export { Calendar };
